import script from "./BaseDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDropdown.vue?vue&type=script&setup=true&lang=js"

import "./BaseDropdown.vue?vue&type=style&index=0&id=1bfe1ed9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bfe1ed9"]])

export default __exports__